module.exports = __webpack_public_path__ + "img/download-zip-icon.ff8224e6.svg";